import { colors } from 'theme/colors';
import { ITableDataSource } from 'models/table';
import { ActivityTypes } from 'constants/ActivityTypes';
import { EChipsVariants } from 'components/atoms/Chips';
import { LegalityTypes } from 'constants/LegalityTypes';
import { EFirearmStateId } from 'models/firearm';

export const renderRowColor = (data: ITableDataSource) => {
  if (data.stateUniqueId === EFirearmStateId.EXPIRED) {
    return colors.warning15;
  }
  if (data.activityUniqueId === ActivityTypes.INACTIVE) {
    return colors.gray100;
  }
  if (data.legalityUniqueId === LegalityTypes.ILLEGAL) {
    return colors.error15;
  }
  return '';
};

export const renderRowColorHover = (data: ITableDataSource) => {
  if (data.stateUniqueId === EFirearmStateId.EXPIRED) {
    return colors.warning25;
  }
  if (data.activityUniqueId === ActivityTypes.INACTIVE) {
    return colors.gray200;
  }
  if (data.legalityUniqueId === LegalityTypes.ILLEGAL) {
    return colors.error25;
  }
  return colors.primary15;
};

export const renderDataColor = (data: ITableDataSource) => {
  if (data) {
    if (data.stateUniqueId === EFirearmStateId.EXPIRED) {
      return {
        background: colors.warning25,
        border: colors.warning400,
        stateField: EChipsVariants.expired,
      };
    }
    if (data.activityUniqueId === ActivityTypes.INACTIVE) {
      return {
        background: colors.gray200,
        border: colors.gray400,
        stateField: EChipsVariants.inactive,
      };
    }
    if (data.legalityUniqueId === LegalityTypes.ILLEGAL) {
      return {
        background: colors.error15,
        border: colors.error100,
        stateField: EChipsVariants.error,
      };
    }
  }
  return {
    background: colors.gray100,
    border: colors.gray200,
    stateField: EChipsVariants.primary,
  };
};

export const renderDataColorByValues = (
  activityUniqueId: string,
  legalityUniqueId: string,
  stateUniqueId: string,
) => {
  if (stateUniqueId === EFirearmStateId.EXPIRED) {
    return {
      background: colors.warning25,
      border: colors.warning400,
      stateField: EChipsVariants.expired,
    };
  }
  if (activityUniqueId === ActivityTypes.INACTIVE) {
    return {
      background: colors.gray200,
      border: colors.gray400,
      stateField: EChipsVariants.inactive,
    };
  }
  if (legalityUniqueId === LegalityTypes.ILLEGAL) {
    return {
      background: colors.error15,
      border: colors.error100,
      stateField: EChipsVariants.error,
    };
  }
  return {
    background: colors.gray100,
    border: colors.gray200,
    stateField: EChipsVariants.primary,
  };
};
